// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"7f1b4783","572":"141de3ca","607":"df19a51b","748":"26ec639f","763":"adcfd995"}[chunkId] + ".chunk.js";
};